import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from "react";
import Divider from "../Divider";
import SectionTitle from "../SectionTitle";
import SectionWrapper from "../SectionWrapper";

interface Props {
  title: Queries.EventPageQuery["datoCmsEvent"]["sectionEmployees"][0]["title"];
  items: Queries.EventPageQuery["datoCmsEvent"]["sectionEmployees"][0]["items"];
}

const EventPageSectionEmployees = ({
  title: [{ title, category }],
  items,
}: Props) => {
  const filteredItems = items.filter((item) => item.pagePath);

  if (filteredItems.length === 0) return null;

  return (
    <SectionWrapper noBorder>
      <Divider additionalClassName="mb-32" />
      <SectionTitle title={title} category={category} />
      <div className="mt-16 grid grid-cols-1 gap-6 max-sm:gap-y-8 sm:grid-cols-2 md:grid-cols-3">
        {filteredItems.map((item) => {
          const {
            primaryPhoto,
            fullname,
            jobTitle,
            shortDescription,
            pagePath,
          } = item;
          const image = getImage(primaryPhoto);
          return (
            <Link
              key={item.pagePath}
              to={pagePath}
              className="group flex flex-col"
            >
              <div className="overflow-hidden">
                <GatsbyImage
                  image={image}
                  alt={primaryPhoto.alt}
                  className="transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="flex-1 bg-gray-50 p-4 pb-8">
                <div className="text-lg group-hover:text-teal-600">
                  {fullname}
                </div>
                <div className="text-lg text-gray-700">{jobTitle}</div>
                <div className="mt-6 text-sm">{shortDescription}</div>
              </div>
            </Link>
          );
        })}
      </div>
    </SectionWrapper>
  );
};

export default EventPageSectionEmployees;
